// New translation keys for recently added web pages/components.
// Add additional keys here to keep App.js lean and avoid missing fallbacks.
const SUPPORTED_LANGS = ['en', 'nb', 'no', 'es', 'fr', 'ar', 'it', 'zh', 'ja', 'am', 'ti'];

const en = {
    // Competitor prices
    competitor_prices: 'Competitor prices',
    competitor_prices_subtitle: 'Track and compare taxi prices from airport kiosks',
    upload_kiosk_photo: 'Upload kiosk photo',
    add_price_entry: 'Add price entry',
    add_manual_entry: 'Add entry manually',
    lowest_price: 'Lowest price',
    highest_price: 'Highest price',
    average_price: 'Average price',
    total_entries: 'Total entries',
    filter_by_route: 'Route',
    all_routes: 'All routes',
    sentral: 'Sentral',
    all_sentrals: 'All sentrals',
    car_type: 'Car type',
    category: 'Category',
    all_types: 'All types',
    sort_by_price: 'Sort by price',
    price_low_high: 'Low -> High',
    price_high_low: 'High -> Low',
    clear_filters: 'Clear filters',
    price_recommendations: 'Price recommendations',
    by_category: 'By category',
    by_company: 'By company',
    all_entries: 'All entries',
    price_rec_info: 'Compare Rydio Taxi prices with competitors. Recommendations aim 1-5 kr lower than the cheapest competitor to win kiosk riders.',
    route: 'Route',
    competitor_lowest: 'Competitor lowest',
    rydio_current: 'Rydio current',
    recommended_price: 'Recommended price',
    status: 'Status',
    add_competitor_data: 'Add competitor price data to see recommendations',
    company: 'Company',
    price: 'Price',
    vehicle: 'Vehicle',
    recorded: 'Recorded',
    actions: 'Actions',
    no_price_data: 'No price data yet',
    no_price_data_subtitle: 'Upload kiosk photos or add entries manually to start tracking competitor prices',
    review_extracted_prices: 'Review extracted prices',
    upload_kiosk_info_ocr: "Upload a photo of the airport kiosk screen. We will automatically extract prices using AI, then you can review and edit before saving.",
    click_to_upload: 'Click to upload image',
    raw_ocr_text: 'Raw OCR text',
    no_prices_extracted: 'No prices could be automatically extracted. Try a clearer image or add entries manually.',
    prices_extracted: 'Found {{count}} price entries. Review and edit below, then save.',
    upload_only: 'Upload only',
    extract_prices: 'Extract prices (AI)',
    extracting: 'Extracting...',
    back: 'Back',
    save_all_prices: 'Save {{count}} prices',
    saving: 'Saving...',
    route_from: 'From',
    route_to: 'To',
    distance: 'Distance',
    year: 'Year',
    avg_price: 'Avg price',
    entries: 'entries',
    entry_label: 'Entry #{{count}}',
    confidence_label: '{{value}}% confidence',
    no_data: 'No data',
    not_set: 'Not set',
    price_winning: 'Winning',
    price_losing: 'Losing',
    price_not_listed: 'Not listed',
    price_equal: 'Equal',
    entries_with_count: '{{count}} entries',
    saving_entry_error: 'Error saving entry: {{message}}',
    saving_prices_error: 'Error saving prices: {{message}}',
    upload_image_error: 'Error uploading image: {{message}}',
    extract_error: 'Could not extract prices automatically. Error: {{message}}\\nYou can still add entries manually.',
    extract_none_alert: 'No prices could be automatically extracted. You can add entries manually or try a clearer image.',
    fetching: 'Fetching...',
    fetching_bolt: 'Fetching Bolt...',
    fetching_uber: 'Fetching Uber...',
    fetching_bergen_taxi: 'Fetching Bergen Taxi...',
    save_prices_success: 'Saved {{count}} price entries.',
    delete_entry_confirm: 'Are you sure you want to delete this entry?',
    bergen_taxi_imported: 'Bergen Taxi prices imported.\\n\\n1-4 Standard: {{standard}} kr\\n5-6 Maxi: {{maxi}} kr\\n\\n{{count}} entries saved.',
    fetch_bergen_error: 'Error fetching Bergen Taxi prices: {{message}}',
    uber_prices_imported: 'Uber price estimates imported.\\n\\nUberX (1-4): {{uberX}} kr\\nUber Comfort: {{comfort}} kr\\nUber XL (5-6): {{xl}} kr{{feeInfo}}\\n\\n{{count}} entries saved.\\n\\nNote: Includes toll (32 kr) + airport fee (10 kr). Actual prices may vary.',
    fetch_uber_error: 'Error fetching Uber prices: {{message}}',
    bolt_prices_imported: 'Bolt price estimates imported.\\n\\nBolt (1-4): {{bolt}} kr\\nBolt Comfort: {{comfort}} kr\\nBolt XL (5-6): {{xl}} kr{{feeInfo}}\\n\\n{{count}} entries saved.\\n\\nNote: Bolt uses flat 7 kr toll (actual is 26-32 kr) + 10 kr airport fee.',
    fetch_bolt_error: 'Error fetching Bolt prices: {{message}}',
    delete_entry_error: 'Error deleting entry: {{message}}',
    uber_fee_info: '\\n\\nPrice breakdown (UberX):\\n- Base fare: {{base}} kr\\n- Airport fee: {{airport}} kr\\n- Toll: {{toll}} kr',
    bolt_fee_info: '\\n\\nPrice breakdown (Bolt):\\n- Base fare: {{base}} kr\\n- Airport fee: {{airport}} kr\\n- Toll: {{toll}} kr (flat rate)',
};

const nb = {
  // Konkurrent-priser
  competitor_prices: 'Konkurrentpriser',
  competitor_prices_subtitle: 'Følg og sammenlign taxipriser fra flyplasskiosker',
  upload_kiosk_photo: 'Last opp kioskbilde',
  add_price_entry: 'Legg til prislinje',
  add_manual_entry: 'Legg til manuelt',
  lowest_price: 'Laveste pris',
  highest_price: 'Høyeste pris',
  average_price: 'Snittpris',
  total_entries: 'Antall linjer',
  filter_by_route: 'Rute',
  all_routes: 'Alle ruter',
  sentral: 'Sentral',
  all_sentrals: 'Alle sentraler',
  car_type: 'Bilkategori',
  category: 'Kategori',
  all_types: 'Alle typer',
  sort_by_price: 'Sorter etter pris',
  price_low_high: 'Lav -> Høy',
  price_high_low: 'Høy -> Lav',
  clear_filters: 'Nullstill filtre',
  price_recommendations: 'Prisanbefalinger',
  by_category: 'Etter kategori',
  by_company: 'Etter selskap',
  all_entries: 'Alle linjer',
  price_rec_info: 'Sammenlign Rydio-priser med konkurrenter. Anbefalinger legger seg 1-5 kr under billigste konkurrent på FastTravel-kiosker.',
  route: 'Rute',
  competitor_lowest: 'Laveste konkurrent',
  rydio_current: 'Rydio nåværende',
  recommended_price: 'Anbefalt pris',
  status: 'Status',
  add_competitor_data: 'Legg til konkurrentpriser for å se anbefalinger',
  company: 'Selskap',
  price: 'Pris',
  vehicle: 'Kjøretøy',
  recorded: 'Registrert',
  actions: 'Handlinger',
  no_price_data: 'Ingen prisdata ennå',
  no_price_data_subtitle: 'Last opp kioskbilder eller legg inn linjer manuelt for å starte sporing av konkurrenter',
  review_extracted_prices: 'Se gjennom hentede priser',
  upload_kiosk_info_ocr: 'Last opp et bilde av kioskskjermen. Vi henter priser automatisk med AI, og du kan rette før lagring.',
  click_to_upload: 'Klikk for å laste opp bilde',
  raw_ocr_text: 'Rå OCR-tekst',
  no_prices_extracted: 'Ingen priser ble hentet automatisk. Prøv et tydeligere bilde eller legg inn manuelt.',
  prices_extracted: 'Fant {{count}} prislinjer. Se over og lagre.',
  upload_only: 'Bare last opp',
  extract_prices: 'Hent priser (AI)',
  extracting: 'Henter...',
  back: 'Tilbake',
  save_all_prices: 'Lagre {{count}} priser',
  saving: 'Lagrer...',
  route_from: 'Fra',
  route_to: 'Til',
  distance: 'Distanse',
  year: 'År',
  avg_price: 'Snittpris',
  entries: 'linjer',
  entry_label: 'Linje #{{count}}',
  confidence_label: '{{value}} % treff',
  no_data: 'Ingen data',
  not_set: 'Ikke satt',
  price_winning: 'Vinner',
  price_losing: 'Taper',
  price_not_listed: 'Ikke listet',
  price_equal: 'Lik',
  entries_with_count: '{{count}} linjer',
  saving_entry_error: 'Kunne ikke lagre linje: {{message}}',
  saving_prices_error: 'Kunne ikke lagre priser: {{message}}',
  upload_image_error: 'Kunne ikke laste opp bilde: {{message}}',
  extract_error: 'Kunne ikke hente priser automatisk. Feil: {{message}}\\nDu kan fortsatt legge inn manuelt.',
  extract_none_alert: 'Ingen priser ble hentet automatisk. Legg inn manuelt eller prøv et tydeligere bilde.',
  fetching: 'Henter...',
  fetching_bolt: 'Henter Bolt...',
  fetching_uber: 'Henter Uber...',
  fetching_bergen_taxi: 'Henter Bergen Taxi...',
  save_prices_success: 'Lagret {{count}} prislinjer!',
  delete_entry_confirm: 'Er du sikker på at du vil slette denne linjen?',
  bergen_taxi_imported: 'Bergen Taxi-priser importert!\\n\\n1-4 Standard: {{standard}} kr\\n5-6 Maxi: {{maxi}} kr\\n\\n{{count}} linjer lagret.',
  fetch_bergen_error: 'Feil ved henting av Bergen Taxi-priser: {{message}}',
  uber_prices_imported: 'Uber-priser importert!\\n\\nUberX (1-4): {{uberX}} kr\\nUber Comfort: {{comfort}} kr\\nUber XL (5-6): {{xl}} kr{{feeInfo}}\\n\\n{{count}} linjer lagret.\\n\\nMerk: Inkluderer bom (32 kr) + flyplassavgift (10 kr). Faktiske priser kan variere.',
  fetch_uber_error: 'Feil ved henting av Uber-priser: {{message}}',
  bolt_prices_imported: 'Bolt-priser importert!\\n\\nBolt (1-4): {{bolt}} kr\\nBolt Comfort: {{comfort}} kr\\nBolt XL (5-6): {{xl}} kr{{feeInfo}}\\n\\n{{count}} linjer lagret.\\n\\nMerk: Bolt bruker flat 7 kr bom (reelt 26-32 kr) + 10 kr flyplassavgift.',
  fetch_bolt_error: 'Feil ved henting av Bolt-priser: {{message}}',
  delete_entry_error: 'Feil ved sletting av linje: {{message}}',
  uber_fee_info: '\\n\\nPrisdetaljer (UberX):\\n- Startpris: {{base}} kr\\n- Flyplassavgift: {{airport}} kr\\n- Bom: {{toll}} kr',
  bolt_fee_info: '\\n\\nPrisdetaljer (Bolt):\\n- Startpris: {{base}} kr\\n- Flyplassavgift: {{airport}} kr\\n- Bom: {{toll}} kr (flat sats)',
};

const translations = {
  en,
  nb,
  no: nb,
};

export const registerNewWebTranslations = (i18n) => {
  SUPPORTED_LANGS.forEach((lang) => {
    const bundle = translations[lang] || translations.en;
    i18n.addResourceBundle(lang, 'translations', bundle, true, true);
  });
};

export default translations;
